import Table, { TableProps, SupportedStyles } from './Table';

export type { SupportedStyles, TableProps };
export default Table;
